import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@ibk/shared-auth';
import { useGetHomePermissions } from '@ibk/shared-permissioning';
import { hasDeepLinkStored } from '@ibk/shared-utils';
export function useDeepLinkRedirect() {
    const { isAuthenticated } = useAuth();
    const { finishedValidations } = useGetHomePermissions();
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        if (!isAuthenticated)
            return;
        if (location.pathname === '/deeplink' || location.pathname === '/deeplink-resolver') {
            return;
        }
        if (location.pathname === '/company-selection') {
            return;
        }
        if (!finishedValidations) {
            return;
        }
        const shouldRedirect = hasDeepLinkStored();
        if (shouldRedirect) {
            navigate('/deeplink-resolver', { replace: true });
        }
    }, [isAuthenticated, finishedValidations, navigate, location.pathname]);
}
